exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".solution-viewer,\n.solution-viewer pre {\n  margin-bottom: 0px;\n}\n\n.solution-viewer {\n  border-color: var(--color-primary);\n}\n", "", {"version":3,"sources":["/app/client/src/components/settings/solution-viewer.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAkB;CACpB;;AAEA;EACE,mCAAkC;CACpC","file":"solution-viewer.css","sourcesContent":[".solution-viewer,\n.solution-viewer pre {\n  margin-bottom: 0px;\n}\n\n.solution-viewer {\n  border-color: var(--color-primary);\n}\n"],"sourceRoot":""}]);

// exports
